import { Empty } from "antd";
import * as React from "react";

import * as styles from "./common.module.less";

/**
 * Компонент отображения пустого состояния таблицы
 */
export const TableEmpty = () => (
  <div className={styles.box}>
    <Empty description="Нет данных" />
  </div>
);
